export {default as randomUniform} from "./uniform";
export {default as randomNormal} from "./normal";
export {default as randomLogNormal} from "./logNormal";
export {default as randomBates} from "./bates";
export {default as randomIrwinHall} from "./irwinHall";
export {default as randomExponential} from "./exponential";



//////////////////
// WEBPACK FOOTER
// ./~/d3-random/src/index.js
// module id = ./node_modules/d3-random/src/index.js
// module chunks = 54